import { render, staticRenderFns } from "./DataSetNavigation.vue?vue&type=template&id=3b2a602f&scoped=true"
import script from "./DataSetNavigation.vue?vue&type=script&lang=js"
export * from "./DataSetNavigation.vue?vue&type=script&lang=js"
import style0 from "./DataSetNavigation.vue?vue&type=style&index=0&id=3b2a602f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2a602f",
  null
  
)

export default component.exports